import { api, APIError, SuccessResponse } from '@/components/api-common';

export type OrgPaymentSettings =
  | {
      support_ach: boolean;
      support_credit_card: boolean;
      enabled: true;
      charge_platform_fee: boolean;
      platform_fee_percent: string;
    }
  | { enabled: false };

export type OrgAlliance = {
  id: string;
  name: string;
  orgs: {
    id: string;
    name: string;
    payment: OrgPaymentSettings;
  }[];
};

export type UserResponse = {
  user_id: string;
  org_id: string;
  enterprise_id: string | null;
  username: string;
  default_org_type: 'COMPANY' | 'INDIVIDUAL';
  is_admin: boolean;
  email: string;
  first_name: string;
  last_name: string;
  phone: string | null;
  stripe_customer_id: string;
  expired: boolean;
  default_org_subs_expire_time: number;
  default_org_purchase_type: string;
  expired_without_extension: boolean;
  org_alliances: OrgAlliance[];
  enable_mvp2_beta: boolean;
  is_enterprise_admin: boolean;
};

export const fetchUser = async (): Promise<UserResponse> => {
  // Use raw api instance to avoid handleApiResponse which redirects on 115 errors
  // This is specifically for auth state checking where 115 is expected
  const url = 'user/service/userAuth/user/v2/';

  const data = await api
    .post(url, { json: {} })
    .json<SuccessResponse<UserResponse>>();

  if (data.result === 'success') {
    return data.data;
  } else {
    // Throw error with the API error structure for consistent handling
    throw new APIError({
      code: data.code,
      message: data.message,
      result: 'failed',
    });
  }
};
